import React, { useCallback, useState } from "react";
import { Outlet } from "react-router";
import { defineMessages } from "react-intl";
import { IconAddressBook, IconShoppingCart, IconWallet } from "@tabler/icons-react";
import { useVisitor } from "@ct-react/visitor";
import Wrapper from "../../components/layout/wrapper";
import CheckoutStepper from "../../components/cart/checkout-stepper";

export type CartContext = {
  readonly sessionId?: string;
  readonly userId?: string;
  readonly index: number;
  readonly changeIndex: (val: number) => void;
}

const transDefs = defineMessages({
  cart: { id: "cart-stepper-cart-label", defaultMessage: "Panier" },
  info: { id: "cart-stepper-info-label", defaultMessage: "Vos informations" },
  pay: { id: "cart-stepper-payment-label", defaultMessage: "Paiement" }
});

const steps = [
  { icon: IconShoppingCart, msg: transDefs.cart },
  { icon: IconAddressBook, msg: transDefs.info },
  { icon: IconWallet, msg: transDefs.pay },
];

const CartOutlet = () => {

  const { sessionId, userId } = useVisitor();
  const [ index, setIndex ] = useState<number>(0);

  const changeIndex = useCallback((val: number) => setIndex(val), []);

  return(
    <div className="rl-cart">
      <Wrapper.Centered className="booking-process">
        <CheckoutStepper steps={steps} activeIndex={index} />
      </Wrapper.Centered>
      <Wrapper.Centered as="main">
        <Outlet context={{ sessionId, userId, index, changeIndex }} />
      </Wrapper.Centered>
    </div>);
}

export default CartOutlet;
